// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ data, ...other }) {
  let { user } = useAuth();
  let data_user = {}
  
  if(data) {
    data_user = data
    data_user.photoURL = data.photo
    data_user.displayName = data.username
  } else {
    data_user = user
  }

  return (
    <MAvatar
      src={data_user.photoURL}
      alt={data_user.displayName}
      color={data_user.photoURL ? 'default' : createAvatar(data_user.displayName).color}
      {...other}
    >
      {createAvatar(data_user.displayName).name}
    </MAvatar>
  );
}
